<!-- 协议确认弹窗 -->
<template>
    <div>
        <veui-dialog ui="auto" :open.sync="open">
            <div class="dialog-content">
                <span>请阅读并知晓</span>
                <span class="form-href-terms" @click.stop="gotoAgreement('serve')">《律师入驻服务条款》</span>
                <span class="form-href-terms" @click.stop="gotoAgreement('agree')">《信息真实承诺书》</span>
                <span class="form-href-terms" @click.stop="gotoAgreement('virtual')">
                    《法行宝虚拟号电话咨询服务协议》
                </span>
                <!-- 【智能体强引导入口下线一期】PRD1：新认证不再自动创建智能体，去除智能体协议链接
                <span
                    v-if="firstApprove === 0" class="form-href-terms"
                    @click.stop="gotoAgreement('agent')"
                >
                    《法行宝律师智能体入驻服务协议》
                </span>
                -->
            </div>
            <template #foot>
                <div class="dialog-footer">
                    <veui-button ui="primary" @click="confirm()">确认</veui-button>
                </div>
            </template>
        </veui-dialog>
    </div>
</template>

<script>
import {Dialog, Button} from 'veui';

export default {
    name: 'AgreeDialog',

    components: {
        'veui-dialog': Dialog,
        'veui-button': Button
    },

    props: {
        firstApprove: {
            type: Number
        }
    },

    data() {
        return {
            open: false
        };
    },

    methods: {
        /**
         * 打开对话框 (父组件会调用到)
         */
        openDialog() {
            this.open = true;
        },

        /**
         * 打开不同类型的协议
         */
        gotoAgreement(type) {
            if (type === 'serve') {
                window.open('https://lvlin-fe-saas.cdn.bcebos.com/lawyer_rule.pdf');
            }
            else if (type === 'virtual') {
                window.open('https://lvlin-fe-saas.cdn.bcebos.com/virtual_number_rule.pdf');
            }
            else if (type === 'agent') {
                window.open('https://lvlin-fe-saas.cdn.bcebos.com/agent-rule.pdf');
            }
            else {
                window.open('https://youjia-image.cdn.bcebos.com/pdf/law-smartapp/160705507337529aaa5c.pdf');
            }
        },
        /**
         * 确认操作
         */
        confirm() {
            this.open = false;
            this.$emit('confirmIsAgree');
        }
    }
};
</script>

<style lang="less" scoped>
.dialog-content {
    width: 250px;
    padding-left: 20px;
    padding-right: 20px;
}

.dialog-footer {
    display: flex;
    justify-content: center;
}

.form-href-terms {
    font-size: 14px;
    color: #0052cc;
    cursor: pointer;
}
</style>
